<ng-container *ngFor="let icon of lstOfIcon; let i = index">
  <ngx-star-icon 
    [isFraction]="icon.isFraction" 
    [isEmpty]="icon.isEmpty" 
    [CssClass]="CssClass" 
    [padding]="options.Padding" 
    [color]="icon.color">
  </ngx-star-icon>
</ng-container>